import dayjs from 'dayjs'

const toDegreesMinutesAndSeconds = (coordinate) => {
  var absolute = Math.abs(coordinate)
  var degrees = Math.floor(absolute)
  var minutesNotTruncated = (absolute - degrees) * 60
  var minutes = Math.floor(minutesNotTruncated)
  var seconds = Math.floor((minutesNotTruncated - minutes) * 60)

  return degrees + '°' + minutes + '\'' + seconds + '"'
}

/**
 * Convert longitude/latitude decimal degrees to degrees minutes and second
 * @param lat latitude degrees decimal
 * @param lng longitude degrees decimal
 */

export const parseLocationDecimal = (lat, lng) => {
  if (!lat && !lng) return ''
  var latitude = toDegreesMinutesAndSeconds(lat)
  var latitudeCardinal = Math.sign(lat) >= 0 ? 'N' : 'S'

  var longitude = toDegreesMinutesAndSeconds(lng)
  var longitudeCardinal = Math.sign(lng) >= 0 ? 'E' : 'W'

  return latitude + latitudeCardinal + ' ' + longitude + longitudeCardinal
}

/**
 * Convert utc timestamp to relative time string
 * @param previous previous time UTC timestamp
 */
export const perseRelativeTime = (previous) => {
  const current = new Date()
  previous = new Date(previous)
  var msPerMinute = 60 * 1000
  var msPerHour = msPerMinute * 60
  var msPerDay = msPerHour * 24
  var msPerMonth = msPerDay * 30
  var msPerYear = msPerDay * 365

  var elapsed = current - previous

  if (elapsed < msPerMinute) {
    return Math.round(elapsed / 1000) + (Math.round(elapsed / 1000) > 1 ? ' detik yang lalu' : ' detik yang lalu')
  } else if (elapsed < msPerHour) {
    return Math.round(elapsed / msPerMinute) + (Math.round(elapsed / msPerMinute) > 1 ? ' menit yang lalu' : ' menit yang lalu')
  } else if (elapsed < msPerDay) {
    return Math.round(elapsed / msPerHour) + (Math.round(elapsed / msPerHour) > 1 ? ' jam yang lalu' : ' jam yang lalu')
  } else if (elapsed < msPerMonth) {
    return 'sekitar ' + Math.round(elapsed / msPerDay) + (Math.round(elapsed / msPerDay) > 1 ? ' hari yang lalu' : ' hari yang lalu')
  } else if (elapsed < msPerYear) {
    return 'sekitar ' + Math.round(elapsed / msPerMonth) + (Math.round(elapsed / msPerMonth) > 1 ? ' bulan yang lalu' : ' bulan yang lalu')
  } else {
    return 'sekitar ' + Math.round(elapsed / msPerYear) + (Math.round(elapsed / msPerYear) > 1 ? ' tahun yang lalu' : ' tahun yang lalu')
  }
}
/**
 * Returns boolean whether previous time is more than inputted minutes
 * @param previous time to be compared
 * @param minutes how many minutes from now
 */
export const isMoreThan = (previous, minutes) => {
  // console.log('TCL: isMoreThan -> previous, minutes', previous, minutes)
  // previous = previous * 1000
  const minutesTimeStamp = minutes * 60 * 1000
  // console.log('TCL: isMoreThan -> previous < ((new Date()) - new Date(minutesTimeStamp)', previous, new Date(), new Date(minutesTimeStamp))
  return previous < ((new Date()) - new Date(minutesTimeStamp))
}

/**
 * parse unix timestamp to date DD-MMMM-YYYY
 * @param {Number} t Unix TimeStamp
 */
export const getDate = (t) => dayjs.unix(t / 1000).format('DD MMMM YYYY')

/**
 * parse unix timestamp to date shorter format DD-MM-YYYY
 * @param {Number} t Unix TimeStamp
 */
export const getDateShort = t => dayjs.unix(t / 1000).format('DD-MM-YYYY')

/**
 * parse uniz timestamp to time HH.MM
 * @param {Number} t Unix TimeStamp
 */
export const getTime = (t) => dayjs.unix(t / 1000).format('HH.mm')
